import React from 'react';
import './Fidelity.css';

export default ({ percentage, absolute }) => (
  <span className={`Fidelity ${absolute !== null ? 'circle' : ''}`}>
    {percentage < 0 || absolute === null ? (
      <span>&mdash;</span>
    ) : (
      <span className={percentage < 30 ? 'red' : percentage < 70 ? 'orange' : 'green'}>{Math.round(percentage)}%</span>
    )}
  </span>
);
